import { ReactNode } from 'react'
import Footer from './Footer'
import WhatsAppButton from './WhatsAppButton'
import StickyHeader from './StickyHeader'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <StickyHeader />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  )
} 